export default {"src":"/_next/static/media/section5-iphone.84d6d1f8.svg","height":585,"width":560,"blurWidth":0,"blurHeight":0};